import { render, staticRenderFns } from "./DashboardpieCharts.vue?vue&type=template&id=09b242f7&"
import script from "./DashboardpieCharts.vue?vue&type=script&lang=js&"
export * from "./DashboardpieCharts.vue?vue&type=script&lang=js&"
import style0 from "./DashboardpieCharts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports